import {Feature} from "../feature";
import type {GraphAtom} from "../graph/GraphAtom";
import {MolecularGraph} from "../graph/MolecularGraph";

export const hydrogenMask = {
    getFeatureImpliedHydrogens: (feature: Feature, graph: MolecularGraph, visibility: boolean) => {
        const hydrogens: GraphAtom[] = [];
        feature.atoms.forEach(a => {
            const bonds = graph.getBondsAttachedTo(a);
            const hsNotInFeature: GraphAtom[] = [];
            bonds.forEach(b => {
                const otherAtom = b.getOtherAtom(a);

                if(otherAtom.symbol === "H" && !feature.atoms.includes(otherAtom)) {
                    if(!otherAtom.visible) {
                        // console.log("other atom visibility", otherAtom.visible)
                    }
                    if(!visibility || (visibility && otherAtom.visible)) {
                        hsNotInFeature.push(otherAtom);
                    }
                }
            })

            hydrogens.push(...hsNotInFeature);
        });

        return hydrogens;
    }
}
